<template>
    <div class="w-full">
        <div class="worked-time-index-top-wrap flex justify-between align-items-center flex-wrap mb-2">
            <button @click="change_month('previous', true)" class="btn btn-primary flex align-items-center mb-2" :ref="'previous_button' + profile_in_use.id" onclick="this.blur()"><i class="fas fa-chevron-left"></i><span class="d-inline-block ml-1 hide-lte-991">Vorige maand</span></button>
            <h4 class="card-title mb-2">{{ this.selected_date }}</h4>
            <button @click="change_month('next', true)" class="btn btn-primary flex align-items-center mb-2" :ref="'next_button' + profile_in_use.id" onclick="this.blur()"><span class="d-inline-block mr-1 hide-lte-991">Volgende maand</span><i class="fas fa-chevron-right"></i></button>
        </div>
        <div class="position-relative overflow-hidden w-100" :ref="'tables_wrap' + this.profile_in_use.id"></div>
    </div>
</template>

<script>
import {createApp, defineComponent} from 'vue';
import SendNewMail from './SendNewMailComponent.vue';

export default {
    data() {
        return {
            year: 0,
            month: 0,
            month_for_id: '00',
            month_names: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
            selected_date: '',
            tables: {},
            current_position: 0,
        }
    },
    props: {
        profile_in_use: {},
        worked_time_statuses: {},
        regular_worked_time_statuses: {},
        overwork_time_statuses: {},
        regular_overwork_time_statuses: {},
        csrf_token: String,
        site_position: String,
        company_is_free: Boolean,
        company_demo_not_expired: Boolean
    },
    // emits: ['mounted'],
    mounted() {
        // this.$nextTick(function() {
        let date = new Date();
        this.year = date.getFullYear();
        this.month = date.getMonth();
        this.month_for_id = '';
        this.add_extra_month('previous', false);
        this.set_dates('previous');
        this.change_month('next', true);
        window.addEventListener('resize', this.change_table_widths);
        // this.$emit('mounted');
        // });
    },
    methods: {
        set_dates: function (direction) {
            if (direction === 'previous') {
                if (this.month === 0) {
                    this.month = 11;
                    this.year--;
                } else {
                    this.month--;
                }
            } else {
                if (this.month === 11) {
                    this.month = 0;
                    this.year++;
                } else {
                    this.month++;
                }
            }

            if (this.month < 10) {
                this.month_for_id = '0' + this.month;
            } else {
                this.month_for_id = this.month;
            }
        },
        set_selected_date: function () {
            this.selected_date = this.month_names[this.month] + ' - ' + this.year;
        },
        change_month: function (direction, not_initial) {
            this.$refs['previous_button' + this.profile_in_use.id].disabled = true;
            this.$refs['next_button' + this.profile_in_use.id].disabled = true;

            this.set_dates(direction);
            let month = this.month;
            let year = this.year;
            let month_for_id = this.month_for_id;

            let tables_wrap = this.$refs['tables_wrap' + this.profile_in_use.id];

            if (!this.tables[year + '' + month_for_id + '' + this.profile_in_use.id]) {
                let axios = require('axios');
                axios.get('/profiles/worked-times/get-from-month?id=' + this.profile_in_use.id + '&month=' + month + '&year=' + year)
                    .then((response) => {
                        this.add_new_table(tables_wrap, response.data, year, month_for_id);
                        this.change_positions(tables_wrap, year, month_for_id, true, direction, not_initial);
                        this.add_extra_month(direction, not_initial);
                        this.change_table_widths();
                        this.set_selected_date();
                    });
            } else {
                this.change_positions(tables_wrap, year, month_for_id, true, direction, not_initial);
                this.add_extra_month(direction, not_initial);
                this.change_table_widths();
                this.set_selected_date();
            }

        },
        add_extra_month: function (direction, not_initial) {

            this.set_dates(direction);
            let month = this.month;
            let year = this.year;
            let month_for_id = this.month_for_id;

            if (!this.tables[year + '' + month_for_id + '' + this.profile_in_use.id]) {
                let axios = require('axios');
                axios.get('/profiles/worked-times/get-from-month?id=' + this.profile_in_use.id + '&month=' + month + '&year=' + year)
                    .then((response) => {
                        let tables_wrap = this.$refs['tables_wrap' + this.profile_in_use.id];
                        this.add_new_table(tables_wrap, response.data, year, month_for_id);
                        this.change_positions(tables_wrap, year, month_for_id, false, direction, not_initial);
                        this.$refs['previous_button' + this.profile_in_use.id].disabled = false;
                        this.$refs['next_button' + this.profile_in_use.id].disabled = false;
                    });
            } else {
                this.$refs['previous_button' + this.profile_in_use.id].disabled = false;
                this.$refs['next_button' + this.profile_in_use.id].disabled = false;
            }

            if (direction === 'next') {
                this.set_dates('previous');
            } else {
                this.set_dates('next');
            }
        },
        add_new_table: function (tables_wrap, response, year, month_for_id) {
            if (!this.tables[year + '' + month_for_id + '' + this.profile_in_use.id]) {
                let parent_wrap = document.createElement('div');
                parent_wrap.classList = 'position-absolute';
                // this.$refs[year + '' + month_for_id + '' + this.profile_in_use.id] = parent_wrap;
                tables_wrap.appendChild(parent_wrap);

                if (response['time_for_time'] === 'false' && response['extra_hours'] === 'false' && response['worked_times'] === 'false') {
                    let p = document.createElement('p');
                    p.classList = 'text-center mb-0 font-size-16';
                    p.innerHTML = 'Er zijn deze maand geen uren geschreven.';
                    parent_wrap.appendChild(p);
                } else {
                    if (response['time_for_time'] !== 'false') {
                        let time_for_time_wrap = document.createElement('div');
                        time_for_time_wrap.classList = 'worked-time-index-wrap';
                        parent_wrap.appendChild(time_for_time_wrap);

                        let time_for_time_title = document.createElement('h4');
                        time_for_time_title.classList = 'card-title d-block';
                        time_for_time_title.innerHTML = 'Tijd voor tijd overuren';
                        time_for_time_wrap.appendChild(time_for_time_title);

                        let table_responsive = document.createElement('div');
                        table_responsive.classList = 'table-responsive';
                        time_for_time_wrap.appendChild(table_responsive);

                        let table = document.createElement('table');
                        table.classList = 'table';
                        table_responsive.appendChild(table);

                        let thead = document.createElement('thead');
                        table.appendChild(thead);

                        let tr = document.createElement('tr');
                        thead.appendChild(tr);

                        let th;
                        th = document.createElement('th');
                        th.innerHTML = 'Datum en tijd';
                        th.style = "width: 25%;";
                        tr.appendChild(th);
                        th = document.createElement('th');
                        th.innerHTML = 'Gewerkte minuten';
                        th.style = `width: ${this.company_is_free ? '25' : '50'}%;`;
                        tr.appendChild(th);
                        if (this.company_is_free) {
                            th = document.createElement('th');
                            th.innerHTML = 'E-mail status';
                            th.style = "width: 25%;";
                            tr.appendChild(th);
                        }
                        th = document.createElement('th');
                        th.classList = 'text-right';
                        th.innerHTML = 'Acties';
                        th.style = "width: 25%;";
                        tr.appendChild(th);

                        let tbody = document.createElement('tbody');
                        table.appendChild(tbody);


                        for (let key in response['time_for_time']) {
                            tr = document.createElement('tr');
                            if (response['time_for_time'][key].status === 1) {
                                tr.classList = 'bg-danger';
                            } else if (response['time_for_time'][key].status === 2) {
                                tr.classList = 'bg-success';
                            }
                            tbody.appendChild(tr);
                            this.create_overwork_time_tr(tr, 'td', response['time_for_time'][key]);
                        }
                    }


                    if (response['extra_hours'] !== 'false') {
                        let extra_hours_wrap = document.createElement('div');
                        extra_hours_wrap.classList = 'worked-time-index-wrap';
                        parent_wrap.appendChild(extra_hours_wrap);

                        let extra_hours_title = document.createElement('h4');
                        extra_hours_title.classList = 'card-title d-block';
                        extra_hours_title.innerHTML = 'Gewerkte overuren';
                        extra_hours_wrap.appendChild(extra_hours_title);

                        let table_responsive = document.createElement('div');
                        table_responsive.classList = 'table-responsive';
                        extra_hours_wrap.appendChild(table_responsive);

                        let table = document.createElement('table');
                        table.classList = 'table';
                        table_responsive.appendChild(table);

                        let thead = document.createElement('thead');
                        table.appendChild(thead);

                        let tr = document.createElement('tr');
                        thead.appendChild(tr);

                        let th;
                        th = document.createElement('th');
                        th.innerHTML = 'Datum en tijd';
                        th.style = `width: 25%;`;
                        tr.appendChild(th);
                        th = document.createElement('th');
                        th.innerHTML = 'Gewerkte minuten';
                        th.style = `width: ${this.company_is_free ? '25' : '50'}%;`;
                        tr.appendChild(th);
                        if (this.company_is_free) {
                            th = document.createElement('th');
                            th.innerHTML = 'E-mail status';
                            th.style = `width: 25%;`;
                            tr.appendChild(th);
                        }
                        th = document.createElement('th');
                        th.classList = 'text-right';
                        th.style = `width: 25%;`;
                        th.innerHTML = 'Acties';
                        tr.appendChild(th);

                        let tbody = document.createElement('tbody');
                        table.appendChild(tbody);


                        for (let key in response['extra_hours']) {
                            tr = document.createElement('tr');
                            if (response['extra_hours'][key].status === 1) {
                                tr.classList = 'bg-danger';
                            } else if (response['extra_hours'][key].status === 2) {
                                tr.classList = 'bg-success';
                            }
                            tbody.appendChild(tr);
                            this.create_overwork_time_tr(tr, 'td', response['extra_hours'][key]);
                        }
                    }


                    if (response['worked_times'] !== 'false') {
                        let worked_times_wrap = document.createElement('div');
                        worked_times_wrap.classList = 'worked-time-index-wrap';
                        parent_wrap.appendChild(worked_times_wrap);

                        let worked_times_title = document.createElement('h4');
                        worked_times_title.classList = 'card-title d-block';
                        worked_times_title.innerHTML = 'Gewerkte uren';
                        worked_times_wrap.appendChild(worked_times_title);


                        let table_responsive = document.createElement('div');
                        table_responsive.classList = 'table-responsive';
                        worked_times_wrap.appendChild(table_responsive);

                        let table = document.createElement('table');
                        table.classList = 'table';
                        table_responsive.appendChild(table);

                        let thead = document.createElement('thead');
                        table.appendChild(thead);

                        let tr = document.createElement('tr');
                        thead.appendChild(tr);

                        let th;
                        th = document.createElement('th');
                        th.innerHTML = 'Datum en tijd';
                        th.style = `width: 25%;`;
                        tr.appendChild(th);
                        th = document.createElement('th');
                        th.innerHTML = 'Gewerkte uren';
                        th.style = `width: 25%;`;
                        tr.appendChild(th);
                        th = document.createElement('th');
                        th.innerHTML = 'Onbetaalde pauze';
                        th.style = `width: 25%;`;
                        tr.appendChild(th);
                        if (this.company_is_free) {
                            th = document.createElement('th');
                            th.innerHTML = 'E-mail status';
                            th.style = `width: 25%;`;
                            tr.appendChild(th);
                        }
                        th = document.createElement('th');
                        th.classList = 'text-right';
                        th.style = `width: 25%;`;
                        th.innerHTML = 'Acties';
                        tr.appendChild(th);

                        let tbody = document.createElement('tbody');
                        table.appendChild(tbody);


                        for (let key in response['worked_times']) {
                            tr = document.createElement('tr');
                            if (response['worked_times'][key].status === 2) {
                                tr.classList = 'bg-danger';
                            } else if (response['worked_times'][key].status === 3) {
                                tr.classList = 'bg-success';
                            }
                            tbody.appendChild(tr);
                            this.create_worked_time_tr(tr, 'td', response['worked_times'][key]);
                        }
                    }
                }
                this.tables[year + '' + month_for_id + '' + this.profile_in_use.id] = {
                    id: year + '' + month_for_id + '' + this.profile_in_use.id,
                    height: parent_wrap.offsetHeight,
                    position: 0,
                    element: parent_wrap
                };

                let index = 0;
                for (let key in this.tables) {
                    this.tables[key]['position'] = index;
                    index++;
                }
            }
        },
        change_positions: function (tables_wrap, year, month_for_id, change_current_position, direction, not_initial) {
            if (change_current_position && not_initial) {
                this.current_position = this.tables[year + '' + month_for_id + '' + this.profile_in_use.id]['position'];
            } else if (!change_current_position) {
                if (direction === 'next') {
                    this.current_position = this.tables[year + '' + month_for_id + '' + this.profile_in_use.id]['position'] - 1;
                } else {
                    this.current_position = this.tables[year + '' + month_for_id + '' + this.profile_in_use.id]['position'] + 1;
                }
            }

            let index = 0;

            for (let key in this.tables) {
                let add_to_position = 0;
                let parent_wrap = this.tables[key].element;

                if (index - this.current_position > 0) {
                    add_to_position = 1;
                }

                parent_wrap.setAttribute('style', 'width: ' + tables_wrap.offsetWidth + 'px; left:' + ((index - this.current_position) * tables_wrap.offsetWidth + add_to_position) + 'px;' + 'transition: ease-in-out 0.4s');
                index++;
            }

            this.set_tables_wrap_height();

        },
        set_tables_wrap_height: function () {
            if (this.tables[this.year + '' + this.month_for_id + '' + this.profile_in_use.id]) {
                let parent_wrap = this.tables[this.year + '' + this.month_for_id + '' + this.profile_in_use.id].element;

                this.$refs['tables_wrap' + this.profile_in_use.id].setAttribute('style', 'height: ' + parent_wrap.offsetHeight + 'px');
            }
        },
        change_table_widths: function () {
            let index = 0;
            let tables_wrap = this.$refs['tables_wrap' + this.profile_in_use.id];

            for (let key in this.tables) {
                let add_to_position = 0;
                if (index - this.current_position > 0) {
                    add_to_position = 1;
                }

                let parent_wrap = this.tables[key].element;
                parent_wrap.setAttribute('style', 'width: ' + tables_wrap.offsetWidth + 'px; left:' + ((index - this.current_position) * tables_wrap.offsetWidth + add_to_position) + 'px;' + 'transition: ease-in-out 0.4s');
                index++;
            }
        },
        create_overwork_time_tr: function (tr, element, overwork_time) {
            let td;
            let b;
            let span;
            let button;
            let div;
            let i;

            td = document.createElement(element);
            span = document.createElement('span');
            span.innerHTML = overwork_time.start_time + ' - ' + overwork_time.end_time;
            td.appendChild(span);
            b = document.createElement('b');
            b.innerHTML = ' / ';
            td.appendChild(b);
            span = document.createElement('span');
            span.innerHTML = overwork_time.date + ' -' + overwork_time.year;
            td.appendChild(span);
            tr.appendChild(td);

            td = document.createElement(element);
            b = document.createElement('b');
            b.innerHTML = overwork_time.minutes;
            td.appendChild(b);
            span = document.createElement('span');
            span.innerHTML = overwork_time.minutes === 1 ? ' minuut' : ' minuten';
            td.appendChild(span);
            tr.appendChild(td);

            if (this.company_is_free) {
                td = document.createElement('td');

                let send_new_mail = Vue.extend(SendNewMail);
                let send_new_mail_instance = new send_new_mail({
                    propsData: {
                        item_kind: 'overwork_time',
                        item: overwork_time,
                        item_statuses: this.regular_overwork_time_statuses
                    }
                });
                send_new_mail_instance.$mount();
                send_new_mail_instance.$parent = this;

                td.appendChild(send_new_mail_instance.$el);
                tr.appendChild(td);
            }

            td = document.createElement(element);
            td.classList = 'text-right';
            if (this.site_position !== 'employer') {
                if (overwork_time.status === 0 || overwork_time.status === 3 || overwork_time.status === 4) {
                    button = document.createElement('button');
                    button.type = 'button';
                    button.classList = 'btn btn-sm btn-danger';
                    if (this.company_demo_not_expired) {
                        button.addEventListener('click', function () {
                            let axios = require('axios');
                            axios.delete('/employee/overwork-times/' + overwork_time.id);
                            this.parentNode.parentNode.remove();
                        });
                    } else {
                        button.disabled = true;
                    }

                    td.appendChild(button);
                    i = document.createElement('i');
                    i.classList = 'fas fa-trash-alt';
                    button.appendChild(i);
                }
            } else {
                let parent_div = document.createElement('div');
                parent_div.classList = 'd-flex justify-content-end text-gray';
                td.appendChild(parent_div);


                div = document.createElement('div');
                div.classList = 'text-success cursor-pointer mr-3';
                if (this.company_demo_not_expired) {
                    div.addEventListener('click', function () {
                        if (overwork_time.status !== 2) {
                            this.parentNode.parentNode.parentNode.classList = 'bg-success';
                            this.parentNode.children[1].classList.add('text-danger');
                            this.classList.remove('text-success');

                            overwork_time.status = 2;

                            let axios = require('axios');
                            axios.put('/employer/overwork-times/' + overwork_time.id, {
                                status: 2
                            })
                        }
                    });
                }

                parent_div.appendChild(div);
                i = document.createElement('i');
                i.classList = 'fas fa-check font-size-20 p-1';
                div.appendChild(i);


                div = document.createElement('div');
                div.classList = 'text-danger cursor-pointer';
                if (this.company_demo_not_expired) {
                    div.addEventListener('click', function () {
                        if (overwork_time.status !== 1) {
                            this.parentNode.parentNode.parentNode.classList = 'bg-danger';
                            this.parentNode.children[0].classList.add('text-success');
                            this.classList.remove('text-danger');
                            overwork_time.status = 1;

                            let axios = require('axios');
                            axios.put('/employer/overwork-times/' + overwork_time.id, {
                                status: 1
                            })
                        }
                    });
                }
                parent_div.appendChild(div);
                i = document.createElement('i');
                i.classList = 'fas fa-times font-size-20 p-1';
                div.appendChild(i);


                if (this.company_demo_not_expired) {
                    if (overwork_time.status === 1) {
                        parent_div.children[1].classList.remove('text-danger');
                    } else if (overwork_time.status === 2) {
                        parent_div.children[0].classList.remove('text-success');
                    }
                } else {
                    parent_div.children[1].classList.remove('text-danger');
                    parent_div.children[0].classList.remove('text-success');
                }
            }

            tr.appendChild(td);
        },
        create_worked_time_tr: function (tr, element, worked_time) {
            let td;
            let b;
            let span;
            let button;
            let div;
            let i;

            td = document.createElement(element);
            span = document.createElement('span');
            span.innerHTML = worked_time.start_time + ' - ' + worked_time.end_time;
            td.appendChild(span);
            b = document.createElement('b');
            b.innerHTML = ' / ';
            td.appendChild(b);
            span = document.createElement('span');
            span.innerHTML = worked_time.date + ' -' + worked_time.year;
            td.appendChild(span);
            tr.appendChild(td);

            td = document.createElement(element);
            b = document.createElement('b');
            b.innerHTML = worked_time.hours;
            td.appendChild(b);
            span = document.createElement('span');
            span.innerHTML = ' uur';
            td.appendChild(span);
            tr.appendChild(td);

            td = document.createElement(element);
            b = document.createElement('b');
            b.innerHTML = worked_time.break;
            td.appendChild(b);
            span = document.createElement('span');
            span.innerHTML = worked_time.break === 1 ? ' minuut' : ' minuten';
            td.appendChild(span);
            tr.appendChild(td);

            if (this.company_is_free) {
                td = document.createElement('td');

                const SendNewMailComponent = defineComponent({
                    extends: SendNewMail,
                    props: {
                        item_kind: String,
                        item: Object,
                        item_statuses: Object,
                    },
                    mounted() {
                        console.log("SendNewMailComponent mounted successfully");
                    },
                });

                console.log({
                    item_kind: 'worked_time',
                    item: worked_time,
                    item_statuses: this.regular_worked_time_statuses,
                });

                const app = createApp(SendNewMailComponent, {
                    item_kind: 'worked_time',
                    item: worked_time,
                    item_statuses: this.regular_worked_time_statuses,
                });

                const sendMailContainer = document.createElement('div');
                app.mount(sendMailContainer);
                td.appendChild(sendMailContainer);
                tr.appendChild(td);
            }

            td = document.createElement(element);
            td.classList = 'text-right';

            if (this.site_position !== 'employer') {
                if (worked_time.status === 1 || worked_time.status === 4 || worked_time.status === 5) {
                    button = document.createElement('button');
                    button.type = 'button';
                    button.classList = 'btn btn-sm btn-danger';
                    if (this.company_demo_not_expired) {
                        button.addEventListener('click', function () {
                            let axios = require('axios');
                            axios.delete('/employee/worked-times/' + worked_time.id);
                            this.parentNode.parentNode.remove();
                        });
                    } else {
                        button.disabled = true;
                    }

                    td.appendChild(button);
                    i = document.createElement('i');
                    i.classList = 'fas fa-trash-alt';
                    button.appendChild(i);
                }
            } else {
                let parent_div = document.createElement('div');
                parent_div.classList = 'd-flex justify-content-end text-gray';
                td.appendChild(parent_div);


                div = document.createElement('div');
                div.classList = 'text-success cursor-pointer mr-3';
                if (this.company_demo_not_expired) {
                    div.addEventListener('click', function () {
                        if (worked_time.status !== 3) {
                            this.parentNode.parentNode.parentNode.classList = 'bg-success';
                            this.parentNode.children[1].classList.add('text-danger');
                            this.classList.remove('text-success');

                            worked_time.status = 3;

                            let axios = require('axios');
                            axios.put('/employer/worked-times/' + worked_time.id, {
                                status: 3
                            })
                        }
                    });
                }

                parent_div.appendChild(div);
                i = document.createElement('i');
                i.classList = 'fas fa-check font-size-20 p-1';
                div.appendChild(i);


                div = document.createElement('div');
                div.classList = 'text-danger cursor-pointer';
                if (this.company_demo_not_expired) {
                    div.addEventListener('click', function () {
                        if (worked_time.status !== 2) {
                            this.parentNode.parentNode.parentNode.classList = 'bg-danger';
                            this.parentNode.children[0].classList.add('text-success');
                            this.classList.remove('text-danger');
                            worked_time.status = 2;

                            let axios = require('axios');
                            axios.put('/employer/worked-times/' + worked_time.id, {
                                status: 2
                            })
                        }
                    });
                }

                parent_div.appendChild(div);
                i = document.createElement('i');
                i.classList = 'fas fa-times font-size-20 p-1';
                div.appendChild(i);


                if (this.company_demo_not_expired) {
                    if (worked_time.status === 2) {
                        parent_div.children[1].classList.remove('text-danger');
                    } else if (worked_time.status === 3) {
                        parent_div.children[0].classList.remove('text-success');
                    }
                } else {
                    parent_div.children[1].classList.remove('text-danger');
                    parent_div.children[0].classList.remove('text-success');
                }
            }

            tr.appendChild(td);
        },
    }
}
</script>
